import React from "react";

export default function AdminAdmins() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-white">Administradores</h1>
        <p className="text-zinc-400 mt-1">Gerencie administradores e permissões</p>
      </div>
      <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-8 text-center">
        <p className="text-zinc-400">Página em desenvolvimento</p>
      </div>
    </div>
  );
}
